import React, { type FC } from 'react';
import { Box, Heading, Text, TextButton } from '@wix/design-system';
import { ExternalLink } from '@wix/wix-ui-icons-common';
import { tabsByIdMapper, tabsByIdMapperNew } from '../../../utils/mappers';
import { useTranslation } from '@wix/wix-i18n-config';
import { DataHooks } from '../../../constants/dataHooks';
import { DOCS } from '../../../constants/routes';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';
import type { TemplateTab } from '../../../types/TemplateTabs';
import { useTabs } from '../../../hooks/useTabs';
import { useExperiments } from '@wix/fe-essentials/react';
import { getIsAppTemplatesRedisgn } from '../../../utils/experiments';

interface Props {
  activeTabId?: TemplateTab;
}

export const TemplatesGridHeading: FC<Props> = ({
  activeTabId: activeTabIdProp,
}) => {
  const { t } = useTranslation();
  const { activeTabId } = useTabs();
  const { experiments } = useExperiments({ readOnly: true });
  const isStartFromScratchRedesignEnabled =
    getIsAppTemplatesRedisgn(experiments);

  const tabsMapper = isStartFromScratchRedesignEnabled
    ? tabsByIdMapperNew
    : tabsByIdMapper;
  const tab = tabsMapper[activeTabIdProp || activeTabId];
  const { reportClickOnDocs } = useTemplatesPageBi();
  const onDocsLinkClick = () => {
    const docsUrl = DOCS[activeTabIdProp || activeTabId];
    reportClickOnDocs(activeTabId, docsUrl);
    window.open(docsUrl);
  };

  return (
    <Box direction="vertical" width="100%">
      <Heading dataHook={DataHooks.GridTitle} size="large">
        {t(tab.gridTitleKey)}
      </Heading>

      <Box gap="100px" align="space-between">
        <Text dataHook={DataHooks.GridSubtitle}>{t(tab.gridSubtitleKey)}</Text>
        <TextButton
          dataHook={DataHooks.GridDocs}
          onClick={onDocsLinkClick}
          suffixIcon={<ExternalLink />}
        >
          {t(tab.gridDocsKey)}
        </TextButton>
      </Box>
    </Box>
  );
};
